import { Component, OnInit } from '@angular/core';
import { BoatService } from '../services/boat.service';
import { Router } from '@angular/router';
import { getBoatImageUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-featbc',
  templateUrl: './featbc.component.html',
  styleUrls: ['./featbc.component.css']
})
export class FeatbcComponent implements OnInit {
  kapalList: any[] = [];
  filteredKapalList: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  tripKategori: string = 'Boat Charter';

  destinations: string[] = ['Komodo National Park', 'Raja Ampat', 'Alor', 'Banda Island'];
  selectedDestination: string = 'Komodo National Park'; // Default destination

  constructor(private boatService: BoatService, private router: Router) {}

  getImageUrl(path: string): string {
    return getBoatImageUrl(path);
  }

  ngOnInit(): void {
    this.fetchKapal();
  }

fetchKapal(): void {
  this.boatService.getFeat2(this.tripKategori)
    .subscribe(response => {
      if (response.success) {
        this.kapalList = response.items.map((boat: any) => {
          if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
            boat.ms_gambarkapals = boat.ms_gambarkapals.map((img: any, i: number) => ({
              ...img,
              loaded: i === 0 // preload hanya gambar pertama
            }));
          }
          return boat;
        });

        this.totalPages = response.totalPages;

        this.filterByDestination(this.selectedDestination);
      }
    }, error => {
      console.error('Error fetching data:', error);
    });
}


  navigateToDetail(slug: string): void {
    this.router.navigate(['/detail-boat', slug]);
  }

  filterByDestination(destination: string): void {
    this.selectedDestination = destination;
    this.filteredKapalList = this.kapalList.filter(boat => 
      boat.ms_tujuans?.some((tujuan: any) => tujuan.tuj === destination)
    );

    // console.log("✅ Destination terpilih:", destination);
    // console.log("🔎 Data setelah filter:", this.filteredKapalList);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.fetchKapal();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.fetchKapal();
    }
  }

  onCarouselSlid(event: any, boat: any): void {
    const items = event.target.querySelectorAll('.carousel-item');
    const activeIndex = Array.from(items).findIndex((item: any) =>
      item.classList.contains('active')
    );

    if (
      boat.ms_gambarkapals &&
      boat.ms_gambarkapals[activeIndex] &&
      !boat.ms_gambarkapals[activeIndex].loaded
    ) {
      boat.ms_gambarkapals[activeIndex].loaded = true;
    }
  }
}
